import { GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import WorkItemTypeIcon from '../work_item_type_icon.vue?vue3';
export default {
    name: 'WorkItemRolledUpCountInfo',
    components: {
        GlSprintf,
        WorkItemTypeIcon
    },
    props: {
        filteredRollUpCountsByType: {
            type: Array,
            required: true
        }
    }
};
